import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { toast } from "sonner";

import { logger } from "@/utils/logger";

import { calcularDatas } from "./periodo";

// Filtro de período de UMA seção. Cada relatório tem o seu (começa em "Este mês"):
// trocar o período em Vendas não muda o de Produtos — regra que a ficha explica.
// `inicial`: o período que o Relatório de Vendas leva para a lista de Clientes
// (e que a lista devolve ao voltar). Os relatórios do menu não usam.
export function usePeriodo(inicial) {
  const [filtro, setFiltro] = useState(inicial?.filtro || "mes");
  const [dataInicio, setDataInicio] = useState(inicial?.dataInicio || "");
  const [dataFim, setDataFim] = useState(inicial?.dataFim || "");
  const periodo = useMemo(() => calcularDatas(filtro, dataInicio, dataFim), [filtro, dataInicio, dataFim]);
  return { filtro, setFiltro, dataInicio, setDataInicio, dataFim, setDataFim, periodo };
}

// Busca `carregar(periodo)` sempre que o período muda. `ativo=false` adia a busca.
// `carregou` só vira true depois da PRIMEIRA resposta (boa ou com erro): é o que
// decide o esqueleto da primeira abertura (25/10/2026). Trocar o período depois
// não volta ao esqueleto — a tela só esmaece enquanto `carregando`.
export function useDados(carregar, periodo, { ativo = true, rotulo = "relatório" } = {}) {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [carregou, setCarregou] = useState(false);
  // Só a resposta do ÚLTIMO pedido vale: clicar "Hoje" e logo "Mês passado"
  // fazia a resposta lenta do primeiro chegar depois e mostrar o período errado.
  const ultimaBusca = useRef(0);

  const recarregar = useCallback(async () => {
    const minha = ++ultimaBusca.current;
    setCarregando(true);
    try {
      const resposta = await carregar(periodo);
      if (minha === ultimaBusca.current) setDados(resposta);
    } catch (erro) {
      if (minha !== ultimaBusca.current) return;
      logger.error(`[RELATORIO] erro ao carregar ${rotulo}:`, erro);
      toast.error(erro?.response?.data?.detail || `Erro ao carregar ${rotulo}`);
    } finally {
      if (minha === ultimaBusca.current) {
        setCarregando(false);
        setCarregou(true);
      }
    }
  }, [carregar, periodo, rotulo]);

  useEffect(() => { if (ativo) recarregar(); }, [ativo, recarregar]);
  return { dados, carregando, carregou, recarregar };
}
